import {NgModule} from "ng-metadata/core";
import {ActiveFacetsTransformationsModule} from "./activeFacetsTransformations/activeFacetsTransformations.module";
import {ActiveFacetsTransformationService} from "./activeFacetsTransformation.service";
import {InactiveFacetsTransformationsModule} from "./inactiveFacetsTransformations/inactiveFacetsTransformations.module";
import {InactiveFacetsTransformationService} from "./inactiveFacetsTransformation.service";


@NgModule({
    declarations: [


    ],
    providers: [
        ActiveFacetsTransformationService,
        InactiveFacetsTransformationService
    ],
    imports:[
        ActiveFacetsTransformationsModule,
        InactiveFacetsTransformationsModule
    ]
})
export class FacetTransformationModule {}

export interface FacetsTransformer {
    transform : (any)=>any;
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/facetTransformation.module.ts